import { render, staticRenderFns } from "./ChannelStep.vue?vue&type=template&id=06fc7a34&scoped=true"
import script from "./ChannelStep.vue?vue&type=script&lang=ts"
export * from "./ChannelStep.vue?vue&type=script&lang=ts"
import style0 from "./ChannelStep.vue?vue&type=style&index=0&id=06fc7a34&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06fc7a34",
  null
  
)

export default component.exports